import React from 'react';
import {observable, action, computed, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import {checkout} from '../../../api';

@observer
class PaymentGiftCard extends React.Component<IPaymentCodesProps> {
    @observable isValid: boolean;

    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.reset = this.reset.bind(this);
        this.change = this.change.bind(this);
        this.isValid = store.checkout.code_gift.value.match(/^[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?/gm) !== null;
        makeObservable(this);
    }

    @action
    change = (e: any) => {
        store.checkout.code_gift.value = e.target.value;
        this.isValid = store.checkout.code_gift.value.match(/^[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?/gm) !== null;
    };

    @action
    submit = async () => {
        store.uiCheckout.isLoadingCart = true;
        const success = await checkout('gift-apply');
        runInAction(() => {
            // approved ria
            store.uiCheckout.isLoadingCart = false;
            this.props.reloadPayment();
        });
    };

    @action
    reset = async () => {
        store.uiCheckout.isLoadingCart = true;
        const success = await checkout('gift-remove');
        runInAction(() => {
            // approved ria
            store.uiCheckout.isLoadingCart = false;
            this.props.reloadPayment();
        });
    };

    render() {
        if (store.PortalID === 3) {
            return <div></div>;
        }

        return (
            <div className="payment-gift-card">
                <div className="row mb-3">
                    <div className="col-12">
                        <div className="h">Enter gift card</div>
                        <div className="gift-card-input">
                            <input
                                name="gift-card"
                                maxLength={50}
                                type="text"
                                aria-label="Gift card"
                                className="form-control tb-promo tb-promo-sm"
                                onChange={this.change}
                                value={store.checkout.code_gift.value}
                                readOnly={store.checkout.code_gift_applied}
                            />
                            {!store.checkout.code_gift_applied && (
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={this.submit}
                                    disabled={!this.isValid}
                                    aria-label="Apply gift card"
                                >
                                    Apply{' '}
                                    {store.uiCheckout.isLoadingCart && (
                                        <span>
                                            <i
                                                className={'fa fa-circle-notch fa-spin'}
                                                aria-hidden={true}
                                            ></i>
                                        </span>
                                    )}
                                </button>
                            )}
                            {store.checkout.code_gift_applied && (
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={this.reset}
                                    aria-label="Remove gift card"
                                >
                                    Remove{' '}
                                    {store.uiCheckout.isLoadingCart && (
                                        <span>
                                            <i
                                                className={'fa fa-circle-notch fa-spin'}
                                                aria-hidden={true}
                                            ></i>
                                        </span>
                                    )}
                                </button>
                            )}
                            {store.checkout.code_gift_applied && (
                                <span className="pad-left">
                                    <span className="badge bg-success">Gift Code Applied!</span>
                                </span>
                            )}
                            {!store.checkout.code_gift_applied &&
                                store.checkout.messages
                                    .filter(o => o.msgType === ICheckoutMessageType.gift)
                                    .map((o, _i) => (
                                        <span
                                            key={_i}
                                            className="pad-left"
                                        >
                                            <span className="badge bg-danger">{o.msg}</span>
                                        </span>
                                    ))}
                        </div>
                    </div>
                    <div
                        className="col-12 mt-1"
                        style={{fontSize: '0.875rem'}}
                    >
                        <a
                            href="/customer-service/gift-card-merge"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{fontSize: '0.875rem', textDecoration: 'underline'}}
                            aria-label="Enter multiple gift cards"
                        >
                            Click here
                        </a>{' '}
                        to enter multiple gift cards.
                    </div>
                </div>
            </div>
        );
    }
}

@observer
class PaymentPromoCode extends React.Component<IPaymentCodesProps> {
    @observable isValid: boolean;
    //  @observable isLoading:boolean;

    constructor(props) {
        super(props);
        // this.isLoading = false;
        this.submit = this.submit.bind(this);
        this.reset = this.reset.bind(this);
        this.cancel = this.cancel.bind(this);
        this.change = this.change.bind(this);
    }

    @action
    change = (e: any) => {
        store.checkout.code_promo.value = e.target.value;
        this.isValid = store.checkout.code_promo.value.length > 0;
    };

    @action
    submit = async () => {
        store.uiCheckout.isLoadingCart = true;
        const success = await checkout('discount-apply');
        runInAction(() => {
            // approved ria
            store.uiCheckout.isLoadingCart = false;
            if (this.props.promoOnly) {
                this.props.reloadPaymentFailure();
            } else {
                this.props.reloadPayment();
            }
        });
    };

    @action
    reset = async () => {
        store.uiCheckout.isLoadingCart = true;
        const success = await checkout('discount-remove');

        runInAction(() => {
            // approved ria
            this.props.reloadPayment();
            if (this.props.promoOnly) {
                location.reload();
            } else {
                store.uiCheckout.isLoadingCart = false;
            }
        });
    };

    @action
    cancel = async () => {
        if (!store.checkout.code_promo_applied) {
            store.checkout.code_promo.value = '';
            this.isValid = true;
        }
        this.props.reloadPayment();
        store.uiCheckout.isLoadingCart = false;
    };

    render() {
        if (this.props.promoOnly) {
            return (
                <div className="payment-gift-card">
                    <div className="row">
                        <div className="col-12">
                            <div className="h">Enter promo code</div>
                            <div className="promo-input">
                                <div className="input-group input-group-sm">
                                    <input
                                        name="discount-code"
                                        maxLength={50}
                                        type="text"
                                        aria-label="Discount code"
                                        className="form-control tb-promo tb-promo-sm"
                                        onChange={this.change}
                                        value={store.checkout.code_promo.value}
                                        readOnly={store.checkout.code_promo_applied}
                                    />
                                    {!store.checkout.code_promo_applied && (
                                        <button
                                            type="button"
                                            className="btn btn-info"
                                            disabled={!this.isValid || store.uiCheckout.isLoadingCart}
                                            onClick={this.submit}
                                            aria-label="Apply promo code"
                                        >
                                            Apply{' '}
                                            {store.uiCheckout.isLoadingCart && (
                                                <span>
                                                    <i
                                                        className={'fa fa-circle-notch fa-spin'}
                                                        aria-hidden={true}
                                                    ></i>
                                                </span>
                                            )}
                                        </button>
                                    )}
                                    {store.checkout.code_promo_applied && (
                                        <button
                                            type="button"
                                            className="btn btn-light"
                                            disabled={store.uiCheckout.isLoadingCart}
                                            onClick={this.reset}
                                            aria-label="Remove promo code"
                                            style={{border: '1px solid #595959'}}
                                        >
                                            Remove{' '}
                                            {store.uiCheckout.isLoadingCart && (
                                                <span>
                                                    <i
                                                        className={'fa fa-circle-notch fa-spin'}
                                                        aria-hidden={true}
                                                    ></i>
                                                </span>
                                            )}
                                        </button>
                                    )}
                                    {!store.checkout.code_promo_applied && (
                                        <button
                                            type="button"
                                            className="btn btn-light"
                                            onClick={this.cancel}
                                            aria-label="Apply promo code"
                                            style={{border: '1px solid #595959'}}
                                        >
                                            Cancel{' '}
                                            {store.uiCheckout.isLoadingCart && (
                                                <span>
                                                    <i
                                                        className={'fa fa-circle-notch fa-spin'}
                                                        aria-hidden={true}
                                                    ></i>
                                                </span>
                                            )}
                                        </button>
                                    )}
                                </div>
                                {store.checkout.code_promo_applied && (
                                    <span className="pad-left">
                                        <span className="badge bg-success">Promo Code applied!</span>
                                    </span>
                                )}
                                {!store.checkout.code_promo_applied &&
                                    store.checkout.messages
                                        .filter(o => o.msgType === ICheckoutMessageType.promo)
                                        .map((o, _i) => (
                                            <div
                                                key={_i}
                                                className="alert alert-danger"
                                                style={{marginTop: 8, marginBottom: 0}}
                                            >
                                                {o.msg}
                                            </div>
                                        ))}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="payment-gift-card">
                    <div className="row">
                        <div className="col-12">
                            <div className="h">Enter promo code</div>
                            <div className="promo-input">
                                <input
                                    name="discount-code"
                                    maxLength={50}
                                    type="text"
                                    aria-label="Discount code"
                                    className="form-control tb-promo"
                                    onChange={this.change}
                                    value={store.checkout.code_promo.value}
                                    readOnly={store.checkout.code_promo_applied}
                                />
                                {!store.checkout.code_promo_applied && (
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                        disabled={!this.isValid || store.uiCheckout.isLoadingCart}
                                        onClick={this.submit}
                                        aria-label="Apply promo code"
                                    >
                                        Apply{' '}
                                        {store.uiCheckout.isLoadingCart && (
                                            <span>
                                                <i
                                                    className={'fa fa-circle-notch fa-spin'}
                                                    aria-hidden={true}
                                                ></i>
                                            </span>
                                        )}
                                    </button>
                                )}
                                {store.checkout.code_promo_applied && (
                                    <button
                                        type="button"
                                        className="btn btn-light"
                                        disabled={store.uiCheckout.isLoadingCart}
                                        onClick={this.reset}
                                        aria-label="Remove promo code"
                                        style={{border: '1px solid #595959'}}
                                    >
                                        Remove{' '}
                                        {store.uiCheckout.isLoadingCart && (
                                            <span>
                                                <i
                                                    className={'fa fa-circle-notch fa-spin'}
                                                    aria-hidden={true}
                                                ></i>
                                            </span>
                                        )}
                                    </button>
                                )}
                                {store.checkout.code_promo_applied && (
                                    <span className="pad-left">
                                        <span className="badge bg-success">Promo Code applied!</span>
                                    </span>
                                )}
                                {!store.checkout.code_promo_applied &&
                                    store.checkout.messages
                                        .filter(o => o.msgType === ICheckoutMessageType.promo)
                                        .map((o, _i) => (
                                            <div
                                                key={_i}
                                                className="alert alert-danger"
                                                style={{marginTop: 8, marginBottom: 0}}
                                            >
                                                {o.msg}
                                            </div>
                                        ))}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

interface IPaymentCodesProps {
    promoOnly: boolean;
    reloadPayment: () => void;
    reloadPaymentFailure: () => void;
}

@observer
class PaymentCodes extends React.Component<IPaymentCodesProps> {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.promoOnly) {
            return (
                <div>
                    <PaymentPromoCode
                        reloadPayment={this.props.reloadPayment}
                        reloadPaymentFailure={this.props.reloadPaymentFailure}
                        promoOnly={true}
                    />
                </div>
            );
        } else {
            return (
                <div>
                    <PaymentGiftCard
                        reloadPayment={this.props.reloadPayment}
                        reloadPaymentFailure={this.props.reloadPaymentFailure}
                        promoOnly={false}
                    />
                    <div className="pad-top">
                        <PaymentPromoCode
                            reloadPayment={this.props.reloadPayment}
                            reloadPaymentFailure={this.props.reloadPaymentFailure}
                            promoOnly={false}
                        />
                    </div>
                </div>
            );
        }
    }
}
export default PaymentCodes;
